// removed by extract-text-webpack-plugin
module.exports = {"overlay":"_-98I8eIP37KaCMxpGBrYY","overlayText":"LvYD9E3YfMhKTiiXz1DR8","loadingOverlay":"znIEfuUT_rkGz9rQ2tS7g","loaderContainer":"_3AKqgnpEFCK2KR_5g0Re-P","circleLoaderContainer":"_1c34FpBBf9__cP6mvb1u9c","circleLoader":"_3FSo-xHHAdjT1cpvBH4gtp","loaderSpin":"_3pogfzOJuiUXWfWKNhoMA7","display":"_206hxmtsdj9qilTefS8_hS"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/overlay.css
// module id = 293
// module chunks = 0